import { DataActions } from "../../store/data/actions";
import { DriveStore } from "../../store/reducers";

export const NO_PIN_VALUE = "-1";

export function getPin(store: DriveStore, driverId?: string, includeNoPin?: boolean): string | undefined {
    let storedPin = driverId ? store.getState().data.inspectionPin[driverId] : undefined;
    return storedPin && (includeNoPin || storedPin !== NO_PIN_VALUE) ? storedPin : undefined;
}

export function setPin(store: DriveStore, value: string, driverId?: string): void {
    value && store.dispatch(DataActions.setInspectionPin({ userId: driverId, inspectionPin: value }));
}

export function setNoPin(store: DriveStore, driverId?: string): void {
    store.dispatch(DataActions.setInspectionPin({ userId: driverId, inspectionPin: NO_PIN_VALUE }));
}

export function removePin(store: DriveStore, driverId?: string): void {
    driverId && store.dispatch(DataActions.clearInspectionPin(driverId));
}

/** True when any driver has an active (PIN-locked) roadside inspection session. */
export function hasLockedRoadsideSession(store: DriveStore): boolean {
    const pins = store.getState().data?.inspectionPin ?? {};
    return Object.keys(pins).some(key => !!pins[key] && pins[key] !== NO_PIN_VALUE);
}

export enum InspectionType {
    HOS_MAIN = "hosMain",
    HOS_REPORT = "hosReport",
    CANELD_HOS_REPORT = "canELDHosReport",
    DVIR_MAIN = "dvirMain",
    DVIR_REPORT = "dvirReport"
}